import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo, useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import _ from 'lodash';

export const GlobalSearch = ({ onSearchFilterTexts, text, style, calendar, tasks, id,name, place }) => {
  const [inputValue, setInputValue] = useState(text || '');

  const debouncedSearch = useMemo(() =>
    _.debounce((value) => {
      onSearchFilterTexts(value);
    }, 400), // Adjust delay as needed
  [onSearchFilterTexts]);

  useEffect(() => {
    debouncedSearch(inputValue);
    return () => {
      debouncedSearch.cancel();
    };
  }, [inputValue]);

  return (
    <div className="input-search-wrapper" style={tasks?{minWidth: "100%", maxWidth: "100%"}:calendar?{width: "16rem"}:{ position: 'relative' }}>
      <div className="search-icon-wrapper">
        <FontAwesomeIcon className="mr-sm-2 search-ico" icon={faSearch} />
      </div>
      <Input
        id={id?id:""}
        name={name?name:""}
        type="text"
        value={inputValue}
        onChange={(e) => {
          const trimmed = e.target.value.trimStart();
          setInputValue(trimmed);
        }}
        placeholder={place?place:"Enter text here..."}
        className="mr-sm-2 pad-fix search-filter search-deal"
        style={style ? style : { width: '17rem', borderColor: '#018EE0' }}
      />
      {!!inputValue && <div style={{ position: 'absolute', right: name=="pp"?"0rem":'1rem', top:calendar?"2px": '0.35em',
      ...(name == "pp" ? { left: "20%" } : { cursor: "pointer" })}}>
        <FontAwesomeIcon style={{ color: '#080707ff' }} icon={faTimes}
        onClick={() => setInputValue('')} />
      </div>}
    </div>
  );
};
